import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={24}
    viewBox="0 0 26 24"
    fill="none"
    {...props}
  >
    <path fill="currentColor" d="m10.936 6.986 7.532 4.475-7.532 4.476v-8.95Z" />
    <path
      fill="currentColor"
      d="M23.49 11c0-2.236-.004-3.777-.165-4.903-.157-1.097-.43-1.537-.764-1.796-.4-.31-1.14-.567-2.69-.7-1.522-.132-3.576-.133-6.424-.133-2.849 0-4.902 0-6.424.132-1.552.134-2.291.39-2.691.701-.333.26-.607.7-.764 1.796-.16 1.126-.164 2.667-.164 4.903 0 2.236.003 3.776.164 4.902.157 1.098.43 1.537.764 1.796.4.311 1.14.567 2.69.702 1.522.131 3.576.132 6.425.132 2.848 0 4.902 0 6.424-.132 1.55-.134 2.29-.39 2.69-.702.333-.259.607-.698.764-1.796.161-1.126.165-2.666.165-4.902ZM26 11c0 2.158.004 3.912-.189 5.258-.196 1.374-.628 2.582-1.707 3.422-1.012.787-2.392 1.08-4.018 1.22-1.656.144-3.839.143-6.64.143-2.8 0-4.983 0-6.639-.142-1.626-.141-3.005-.434-4.017-1.221-1.08-.84-1.512-2.048-1.708-3.422C.89 14.913.893 13.158.893 11s-.003-3.913.189-5.258C1.278 4.368 1.71 3.16 2.79 2.32 3.802 1.533 5.18 1.24 6.807 1.1c1.656-.144 3.84-.143 6.64-.143s4.983 0 6.64.142c1.625.14 3.005.434 4.017 1.221 1.079.84 1.511 2.048 1.707 3.422.193 1.345.19 3.1.19 5.258Z"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
